module.exports = __webpack_public_path__ + "static/media/star.4aef4778.svg";